import { SWRConfig } from 'swr';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { PersistGate } from 'redux-persist/integration/react';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import {  InteractionType } from '@azure/msal-browser';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';

import { RouterProvider, RouterProviderProps } from 'react-router-dom';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { loginRequest } from '@config/authConfig';
import { NotistackProvider } from '@shared/components/Notistack/NotistackProvider';


import { persistor } from '@store/store';
import { swrConfig } from '../network';
import { ILendingLoader } from './shared/components/IlendingLoader';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

export const App = ({ router }: { router: RouterProviderProps['router'] }) => {

  return (
    <PersistGate
      loading={<ILendingLoader />}
      persistor={persistor}
    >
      <SWRConfig value={swrConfig}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <NotistackProvider>
            <MsalAuthenticationTemplate
              loadingComponent={ILendingLoader}
              authenticationRequest={loginRequest}
              interactionType={InteractionType.Redirect}
            >
              <RouterProvider router={router} />
            </MsalAuthenticationTemplate>

            <Notistack />
          </NotistackProvider>
        </LocalizationProvider>
      </SWRConfig>
    </PersistGate>
  );
};
